import React from 'react'
import PropTypes from 'prop-types'
import styles from './Select.module.scss'
import Field from './Field'
import i18next from 'i18next'

const StyledSelect = ({ style, isCompact, ...props }) => {
	return (
		<div
			style={style}
			className={`${styles.root} ${props.inline ? 'inline' : ''} ${isCompact ? styles.isCompact : ''}`}
		>
			<Field {...props}/>
		</div>
	)
}


StyledSelect.propTypes = {
	field: PropTypes.string,
	options: PropTypes.array,
	noForm: PropTypes.bool,
	simpleValue: PropTypes.bool,	// if true `onChange` events and form updates will receive only `option.value` as selected option, does not work with `isMulti` prop
	remoteOptions: PropTypes.shape({
		query: PropTypes.object,
		variables: PropTypes.object,
		valueField: PropTypes.string,
		labelField: PropTypes.string,
		modifyOptions: PropTypes.func,
		additionalOptions: PropTypes.array,
		sort: PropTypes.array
	}),
	beforeSetSelectValue: PropTypes.func, // Should return option object or array of option objects
	beforeSetFormValue: PropTypes.func, // Should return value which be set to form, also accepted Promises
	noOptionsMessage: PropTypes.func,
	isClearable: PropTypes.bool,
	uncontrolled: PropTypes.bool, // Selected option will be handled internally by Select. 'defaultValue' prop can be provided for the selected value on mount.
	isCompact: PropTypes.bool
}

StyledSelect.defaultProps = {
	noOptionsMessage: () => i18next.t('common.fields.no_options_message'),
	simpleValue: true,
	isClearable: false
}

export default StyledSelect
